<template>
  <div v-if="accountsEnabled" class="account-icon-container">
    <a href="https://shopify.com/49286807715/account/orders" aria-label="Go to account" v-if="isB2B">
      <icon name="account" size="24px" class="navbar-account" :style="iconColors"></icon>
    </a>
    <a href="/account" aria-label="Go to account" v-else>
      <icon name="account" size="24px" class="navbar-account" :style="iconColors"></icon>
    </a>
    
  </div>
</template>

<script>
import IconLink from '@/scripts/components/buttons/IconLink.vue'
import Icon from '@/scripts/components/basic/Icon.vue'

export default {
  name: 'NavbarAccount',
  components: { IconLink, Icon },
  computed:{
    iconColors(){
      return { 
          fill: `${this.iconColor.color} !important`
      }
    }
  },
  props: {
    iconColor: {
      type: String,
      default: () => "#000"
    },
    b2b: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    isB2B () {
      console.log(this.b2b, 'b2b')
      return this.b2b
    }
  },
  data () {
    return {
      accountsEnabled: window.bvaccel && window.bvaccel.customer.accountsEnabled
    }
  },
  methods: {}
}
</script>

<style scoped lang="scss">
.account-icon-container {
  a {
    display: flex;
  }
}
.navbar-account {
  max-width: 18px;
  max-height: 23px;
}
svg.navbar-account.icon.icon--account {
    fill: #000 !important;
}
</style>
